import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SanitizeService } from 'src/app/shared/services/sanitize.service';
import { ToastrService } from 'ngx-toastr';

interface KeyConcept {
    name: string;
    isSearch: boolean;
    isRelevance: boolean;
}
interface Topic {
    keyConcept: Array<KeyConcept>;
}

@Component({
    selector: 'app-key-concept',
    templateUrl: './key-concept.component.html',
    styleUrls: ['./key-concept.component.scss'],
})
export class KeyConceptComponent implements OnInit {
    inputValue: string = '';
    keyConcepts: Array<KeyConcept> = [];
    prevKeyConcepts: Array<KeyConcept> = [];
    @Input() topic!: Topic;
    @Output() save = new EventEmitter<Array<KeyConcept>>();
    isMobile = false;
    @Input() modal!: NgbActiveModal;
    constructor(
        private sanitizeService: SanitizeService,
        private toastrService: ToastrService,
    ) {}
    ngOnInit(): void {
        this.checkWidth();
        if (this.topic && this.topic.keyConcept) {
            this.prevKeyConcepts = this.topic.keyConcept;
            this.keyConcepts = [...this.topic.keyConcept]; // Load existing key concepts;
        }
    }
    // addKeyConcepts(): void {
    //     console.log("this.keyConcepts and input are",JSON.stringify(this.keyConcepts),this.inputValue)
    //     const values = this.inputValue
    //         .split(',')
    //         .map((val) => val.trim())
    //         .filter((val) => val);
    //     values.forEach((value) => {
    //         this.keyConcepts.push({
    //             name: value,
    //             isSearch: false,
    //             isRelevance: true,
    //         });
    //     });
    //     this.inputValue = ''; // Clear the input after processing
    // }

    addKeyConcepts(): void {
        console.log('this.keyConcepts and input are', JSON.stringify(this.keyConcepts), this.inputValue);

        const values = this.inputValue
            .split(',')
            .map((val) => val.trim())
            .filter((val) => val);
        console.log(values);
        //const arrayValues = this.validateArrayValues(values); // checking for any values other than alphanumber, +,-, &
        //if (arrayValues) {
        values.forEach((value) => {
            const sanitizedValue = this.sanitizeService.sanitizeInput(value);

            // Only update and emit if the sanitized value differs
            if (value !== sanitizedValue) {
                value = sanitizedValue;
            }
            console.log('keyValues..', value);
            // Perform case-insensitive check to see if value is already present
            if (!this.keyConcepts.some((kc) => kc.name.toLowerCase() === value.toLowerCase())) {
                this.keyConcepts.push({
                    name: value, // Keep the original case for display purposes
                    isSearch: false,
                    isRelevance: true,
                });
            }
        });
        //}

        this.inputValue = ''; // Clear the input after processing

        this.prevKeyConcepts = this.keyConcepts;
    }

    validateArrayValues(inputArray: any) {
        const allowedPattern = /^[a-zA-Z+\-& ]*$/;

        for (const value of inputArray) {
            if (!allowedPattern.test(value)) {
                return false;
            }
        }
        return true;
    }

    onPaste(event: ClipboardEvent): void {
        event.preventDefault();

        if (event.clipboardData) {
            const pastedData = event.clipboardData.getData('text');
            const sanitizedData = this.sanitizeService.sanitizeInput(pastedData);
            if (pastedData !== sanitizedData) {
                this.toastrService.warning('Invalid characters are not allowed');
            }
            (event.target as HTMLInputElement).value = sanitizedData;
        }
    }

    sanitizeInput(event: any) {
        const keyword = (event.target as HTMLInputElement).value;
        console.log('the string is', keyword);

        const sanitizedData = this.sanitizeService.sanitizeInput(keyword);
        if (keyword !== sanitizedData) {
            this.toastrService.warning('Invalid characters are not allowed');
        }
        (event.target as HTMLInputElement).value = sanitizedData;
    }

    removeKeyConcept(index: number): void {
        this.keyConcepts.splice(index, 1);
        console.log(this.prevKeyConcepts);
    }

    saveKeyConcepts(): void {
        console.log(this.keyConcepts);
        this.save.emit(this.keyConcepts);
    }

    checkWidth() {
        const width = window.innerWidth;
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    closeModal() {
        this.modal.dismiss('Cross click');
    }
}
